module.exports = __webpack_public_path__ + "static/house-of-travel-8311b479a33853999e134117ad49c5b0.webp";